module.exports = "<div *ngIf=\"data.length\">\n  <app-skills-section [data]=\"data[0]\" [bgColor]=\"color[0]\"></app-skills-section>\n  <app-skills-section [data]=\"data[1]\" [bgColor]=\"color[1]\"></app-skills-section>\n  <app-skills-section [data]=\"data[2]\" [bgColor]=\"color[2]\"></app-skills-section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/displayer/skills/skills.component.html
// module id = ../../../../../src/app/displayer/skills/skills.component.html
// module chunks = main